import { render } from "./EventSponsorImageForm.vue?vue&type=template&id=0beaacd0&scoped=true"
import script from "./EventSponsorImageForm.vue?vue&type=script&lang=js"
export * from "./EventSponsorImageForm.vue?vue&type=script&lang=js"

import "./EventSponsorImageForm.vue?vue&type=style&index=0&id=0beaacd0&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0beaacd0"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QImg,QFile,QIcon,QBtn,QField});
